
/* injects from baggage-loader */

'use strict';

import PageNotFoundController from './page-not-found.controller';
import PageNotFoundTemplate from './page-not-found.html';

export default class PageNotFoundComponent {
		constructor() {
				this.templateUrl = PageNotFoundTemplate;
				this.controller = PageNotFoundController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/page-not-found/page-not-found.component.js